module.exports = __webpack_public_path__ + "static/media/anc7kz.709a0df6.pdf";